import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, MessageBarType, Panel, PanelType, PrimaryButton, Stack } from '@fluentui/react';
import { UserListView } from './UserListView';
import { useBoolean, useId } from '@fluentui/react-hooks';
import UserProperties from '../UserProperties/UserProperties';
import { IUserListItem } from '../../../../Models/Admin/IUserListItem';
import * as Services from '../../../../Services/Services';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { IAdminApi } from '../../../../Services/API/Admin/IAdminApi';
import { NewUserPanel } from '../UserProperties/NewUserPanel';
import {IAttendee} from "../../../../Models/Attendees/IAttendee";

interface IUserListProps {

}

const dialogStyles = { main: { maxWidth: 450 } };

export const UserList: React.FunctionComponent<IUserListProps> = (props) => {

    const [loadedUserList, setLoadedUserList] = React.useState<IUserListItem[]>([]);
    const [userList, setUserList] = React.useState<IUserListItem[]>([]);
    const [isOpen, setIsOpen] = useBoolean(false);
    const [selectedUser, setSelectedUser] = React.useState<string>();
   

    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isNewUserOpen, setIsNewUserOpen] = useBoolean(false);
    const [isDeleteTeacherOpened, setIsDeleteTeacherOpened] = useBoolean(false);
    const [text, setText] = React.useState("");
    const [role, setRole] = React.useState("");
    const [aktivni, setAktivni] = React.useState(true);

    const [order, setOrder] = React.useState<{ columnKey: string | null, isAsc: boolean }>({ columnKey: null, isAsc: true });


    const onUserSelected = (id?: string) => {
        setSelectedUser(id);
    }

    const newUser = () => {
        setSelectedUser(undefined);
        setIsNewUserOpen.setTrue();
    }

    const loadData = async (text: string, role: string, aktivni: boolean) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const adminApi = Services.ServicesProvider.GetService<IAdminApi>(Services.AdminApi);
        const users = await adminApi.getUsers(text, role, aktivni);

        if (users.isSuccess && users.data) {
            setStatusMessage({ message: users.message, type: MessageBarType.success });
            setUserList(users.data);
            setLoadedUserList(users.data);
        }
        else {
            setStatusMessage({ message: users.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }
    const refresh = () => {
        loadData(text, role, aktivni);
    }
    
    React.useEffect(() => {
        refresh();
    }, [text, role, aktivni])

    const removeUser = async () => {
        if (selectedUser) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);
            const adminApi = Services.ServicesProvider.GetService<IAdminApi>(Services.AdminApi);
            const users = await adminApi.removeUser(selectedUser);

            if (users.isSuccess) {                
                refresh();
                setIsDeleteTeacherOpened.setFalse();
            }
            else {
                setStatusMessage({ message: users.message, type: MessageBarType.error });
            }
            setIsLoading.setFalse();
        }
    }


    const editUser = (id: string) => {
        setSelectedUser(id);
        setIsOpen.setTrue();
    }

    const orderData = (filteredList: IUserListItem[]) => {
        if (!order.columnKey) {
            return;
        }

        const sorted = [...filteredList].sort((a, b) => {
            let key = order.columnKey as keyof IUserListItem;
            
            const valueA = a[key];
            const valueB = b[key];

            // Handle undefined or null values
            if (valueA == null) return 1;
            if (valueB == null) return -1;

            if (order.isAsc) {
                return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
            } else {
                return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
            }
        });

        setUserList(sorted);
    }

    const exportToCsv = () => {
        let csvContent = "\uFEFF Jméno;Příjmení;Email;Telefon;Ulice;Město;\n";

        userList.forEach((item) => {

            let row = `${item.firstName};${item.lastName};${item.email};${item.phoneNumber};${item.street};${item.city};`;
            csvContent = csvContent + row + "\n";
        });
        var link = document.createElement("a");
        const url = URL.createObjectURL(new Blob([csvContent], {
            type: "data:text/csv;charset=utf-8"
        }));
        link.setAttribute("href", url);
        link.setAttribute("download", "registrovaniUzivatele.csv");
        document.body.appendChild(link); // Required for FF
        link.click();
        link.remove();
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        if (!order.columnKey) {
            setUserList(loadedUserList);
        } else {
            orderData(loadedUserList);
        }
    }, [order])

    return (
        <Stack>
            <UserListView
                text={text}
                setText={setText}
                role={role}
                setRole={setRole}
                aktivni={aktivni}
                setAktivni={setAktivni}
                exportToCsv={exportToCsv}
                selectedUser={selectedUser} 
                editUser={editUser} 
                removeUser={setIsDeleteTeacherOpened.setTrue} 
                isLoading={isLoading} 
                items={userList} 
                onUserSelected={onUserSelected} 
                onNewUser={newUser}
                order={order}
                setOrder={setOrder}
            />
            {isOpen ?
                <Panel
                    isOpen={isOpen}
                    onDismiss={setIsOpen.setFalse}
                    type={PanelType.medium}
                    closeButtonAriaLabel="Zavřít">
                    <UserProperties userId={selectedUser} refresh={refresh} />
                </Panel> : null}
            {isNewUserOpen ?
                <NewUserPanel refreshList={(id: string) => { refresh() }} isOpen={isNewUserOpen} close={setIsNewUserOpen.setFalse} /> : null}

            {isDeleteTeacherOpened ?
                <Dialog
                    hidden={!isDeleteTeacherOpened}
                    onDismiss={setIsDeleteTeacherOpened.setFalse}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: "Odstranění uživatele",
                        subText: "Opravdu ostranit uživatele?"
                    }}
                    modalProps={{ isBlocking: true }}>
                    <DialogFooter>
                        <PrimaryButton onClick={removeUser} text="Odstranit" />
                        <DefaultButton onClick={setIsDeleteTeacherOpened.setFalse} text="Zavřít" />
                    </DialogFooter>
                </Dialog> : null}

          </Stack>
        )
}